<template>
    <div id="app">
        <HomePage/>
    </div>
</template>

<script>
import HomePage from './components/HomePage.vue'

export default {
    name: 'App',
    components: {HomePage}
}
</script>

<style>
    html, body, #app {
        height: 100%;
        margin: 0;
        padding: 0;
    }
    body{
        font-family: '微软雅黑', '宋体', 'Arial';
        font-size: 14px;
        color: #323232;
        background-color: #F7F7F7;
    }
</style>
